<template>
  <header class="navbar" role="banner">
    <div class="navbar-container">
      <router-link to="/" class="navbar-logo" aria-label="Página Inicial">
        <img :src="logo" alt="Logo da FFJB - Juventude e Bem-Estar" class="logo-image" />
      </router-link>

      <button class="navbar-toggle" @click="toggleMenu" aria-label="Abrir menu de navegação">☰</button>

      <nav :class="['navbar-menu', { 'is-active': menuOpen }]" role="navigation" aria-label="Menu principal">
        <template v-for="(link, index) in links" :key="index">

          <!-- Link com submenu: Serviços -->
          <div v-if="link.label === 'Serviços'" class="submenu-wrapper"
            @mouseenter="onDesktop ? submenuOpen = true : null"
            @mouseleave="onDesktop ? submenuOpen = false : null">

            <div class="nav-button" @click="handleServicosClick">
              Serviços
            </div>

            <div class="submenu" v-show="submenuOpen">
              <router-link
                v-for="(servico, i) in servicos"
                :key="i"
                :to="servico.to"
                class="submenu-item"
                @click="closeMenu"
              >
                {{ servico.label }}
              </router-link>
            </div>
          </div>

          <!-- Outros links do menu -->
          <router-link
            v-else
            :to="link.to"
            class="nav-button"
            @click="closeMenu"
          >
            {{ link.label }}
          </router-link>
        </template>
      </nav>
    </div>
  </header>
</template>

<script>
import logo from '@/assets/images/ffjblogo.jpg';

export default {
  name: "FfjbNavbar",
  data() {
    return {
      menuOpen: false,
      submenuOpen: false,
      onDesktop: window.innerWidth > 768,
      logo,
      links: [
        { label: "Início", to: "/" },
        { label: "Sobre", to: "/sobre" },
        { label: "Serviços", to: "/servicos" },
        { label: "Projetos", to: "/projetos" },
        { label: "Blog", to: "/blog" },
        { label: "Contato", to: "/contacto" },
      ],
      servicos: [
        { label: "Eletrônica", to: "/servicos/eletronica" },
        { label: "Eletricidade", to: "/servicos/eletricidade" },
        { label: "Climatização", to: "/servicos/climatizacao" },
        { label: "Automação", to: "/servicos/automacao" },
        { label: "Máquinas e Motores", to: "/servicos/manutencao" },
        { label: "Elevadores", to: "/servicos/elevadores" },
        { label: "Esteiras Elétricas", to: "/servicos/esteiras" },
        { label: "Portas Automáticas", to: "/servicos/portas" },
        { label: "Telecomunicações", to: "/servicos/telecomunicacao" },
        { label: "Desenvolvimento de Projetos de Eletromecânica", to: "/servicos/eletromecanica" },

      ],
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    closeMenu() {
      this.menuOpen = false;
      this.submenuOpen = false;
    },
    handleResize() {
      this.onDesktop = window.innerWidth > 768;
    },
    handleServicosClick() {
      if (!this.onDesktop) {
        this.submenuOpen = !this.submenuOpen; // abre submenu no mobile
      } else {
        this.$router.push("/servicos"); // redireciona no desktop
      }
    },
  },
};
</script>

<style>
/* Navbar básica */
.navbar {
  background-color: #112e51;
  color: white;
  padding: 1rem;
  position: relative;
  z-index: 100;
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.logo-image {
  height: 50px;
}

.navbar-toggle {
  display: none;
  font-size: 1.5rem;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
}

/* Menu principal */
.navbar-menu {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.nav-button {
  background: none;
  border: none;
  color: white;
  font-weight: bold;
  cursor: pointer;
  padding: 0.5rem 1rem;
  text-decoration: none;
  user-select: none;
  transition: background-color 0.3s, color 0.3s;
}

/* Hover para botões */
.nav-button:hover {
  text-decoration: underline;
  color: #0fdf8a;
}

/* Submenu */
.submenu-wrapper {
  position: relative;
}

.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: #173d5e;
  border-radius: 0.5rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 220px;
}

.submenu-item {
  color: white;
  padding: 0.75rem 1rem;
  text-decoration: none;
  border-bottom: 1px solid #ffffff22;
  transition: background-color 0.3s, color 0.3s;
}

/* Hover submenu */
.submenu-item:hover {
  text-decoration: underline;
  color: #0fdf8a;
}

/* Responsividade */
@media (max-width: 768px) {
  .navbar-toggle {
    display: block;
  }

  .navbar-menu {
    display: none;
    flex-direction: column;
    background-color: #112e51;
    width: 100%;
    position: absolute;
    top: 64px;
    left: 0;
    padding: 1rem 0;
  }

  .navbar-menu.is-active {
    display: flex;
  }

  .nav-button {
    width: 90%;
    margin: 0.5rem auto;
    text-align: center;
  }

  .submenu {
    position: static;
    box-shadow: none;
    border-radius: 0;
    background-color: #0e2c47;
  }

  .submenu-item {
    border: none;
  }
}
</style>
